import { defineMessages } from 'react-intl';

export default defineMessages({
    assignClasses: {
        id: 'app.components.TeacherClassDetail.assignClasses',
        defaultMessage: 'Assign Class(es)'
    },
    classDetails: {
        id: 'app.components.TeacherClassDetail.classDetails',
        defaultMessage: 'Class details'
    }
});



// WEBPACK FOOTER //
// ./app/components/teacher-class-detail/messages.js